import React, { createContext, useState } from "react";

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(false);

  const lightTheme = {
    darkMode: false,
    background: "#f9fafb",
    cardBackground: "white",
    text: "#111827",
    buttonText: "white",
    primary: "#009BBF",
  };

  const darkTheme = {
    darkMode: true,
    background: "#1f2937",
    cardBackground: "#374151",
    text: "#f9fafb",
    buttonText: "white",
    primary: "#009BBF",
  };

  const toggleTheme = () => setDarkMode(!darkMode);

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ ...theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
